import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const LoadingState = ({
  children,
  spinnerColor = 'var(--primary-color)',
  spinnerSize,
  gap = 2,
  fullHeight = false,
}) => {
  return (
    <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: fullHeight ? '100%' : 'auto',
          flex: fullHeight ? 1 : 'unset',
          minHeight: 0,
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap,
          }}
        >
          <CircularProgress sx={{ color: spinnerColor }} size={spinnerSize} />
          {children}
        </Box>
    </Box>
  );
};

export default LoadingState;
